import { css } from 'linaria';

export const complexCards = css`
  display: flex;
  column-gap: 32px;

  @media (--only-tablet) {
    column-gap: 24px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 12px;
  }
`;

export const cardColumnOne = css`
  width: 765px;

  @media (--only-desktop) {
    width: 603px;
  }

  @media (--only-tablet) {
    width: 330px;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const cardImage = css`
  border-radius: var(--rounding-xl);
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const cardColumnTwo = css`
  width: 377px;
  display: flex;
  flex-direction: column;
  row-gap: 32px;

  @media (--only-desktop) {
    width: 305px;
  }

  @media (--only-tablet) {
    width: 330px;
    row-gap: 24px;
  }

  @media (--only-mobile) {
    width: 100%;
    row-gap: 12px;
  }
`;
